import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateSyncYourPhone = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 559.7 493.26",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".c{opacity:.1;}.d{fill:#ebf3ff;}.e{fill:#fafcff;}.f,.g{fill:#9ec5ff;}.h{fill:#dcebfe;}.g{fill-rule:evenodd;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "a",
			children: /* @__PURE__ */ _jsx("circle", {
				className: "e",
				cx: 246.8,
				cy: 246.79,
				r: 246.8
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "b",
			children: [/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
				className: "h",
				d: "M383.11,345.34c-.08-.28-.17-.56-.28-.82,19.72-27.54,31.33-61.27,31.33-97.73,0-92.8-75.23-168.02-168.02-168.02S78.12,153.99,78.12,246.79s75.23,168.02,168.02,168.02c36.22,0,69.76-11.46,97.2-30.95l43.44,25.61c5.85,3.45,12.94-1.93,11.18-8.49l-14.86-55.64Z"
			}), /* @__PURE__ */ _jsx("path", {
				className: "g",
				d: "M331.22,288.1l-36.73-18.86c-1.49-.5-3.47-.5-4.96,.99l-14.89,14.89c-1.49,1.49-2.98,1.99-4.96,.99-22.83-10.42-46.65-34.24-57.57-57.57-.5-1.49,0-2.98,.99-4.47l15.38-15.38c.99-.99,1.49-2.98,.5-4.47l-18.86-36.73c-.99-2.48-3.47-2.98-5.46-1.99-8.44,4.47-15.38,9.93-20.84,15.88-11.91,12.9-14.89,29.78-8.93,45.66,17.87,47.15,49.63,78.91,96.77,96.77,15.88,5.96,32.76,2.48,45.66-8.93,5.96-5.46,11.41-12.41,15.88-20.84,.99-1.99,0-4.47-1.99-5.96h0Z"
			})] }), /* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsx("path", {
					className: "c",
					d: "M375.81,95.97l-46.65,80.8c-3.11,5.39,.78,12.12,7,12.12h93.3c6.22,0,10.11-6.74,7-12.12l-46.65-80.8c-3.11-5.39-10.89-5.39-14,0Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "f",
					d: "M383.02,90.71l-46.65,80.8c-3.11,5.39,.78,12.12,7,12.12h93.3c6.22,0,10.11-6.74,7-12.12l-46.65-80.8c-3.11-5.39-10.89-5.39-14,0Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "d",
					d: "M384.3,109.54h11.44v19.38l-3.23,24.01h-4.98l-3.23-24.01v-19.38Zm11.44,50.46v11.44h-11.35v-11.44h11.35Z"
				})
			] })]
		})
	]
});
export default SvgEmptyStateSyncYourPhone;
